module.exports = __webpack_public_path__ + "static/media/image13.ec128f29.jpg";